module.exports = [
  {"catid":"201", "name": "Alternatives"},
  {"catid":"202", "name": "Country"},
  {"catid":"203", "name": "EDM"},
  {"catid":"204", "name": "Dance"},
  {"catid":"206", "name": "Indie"},
  {"catid":"207", "name": "Jazz"},
  {"catid":"208", "name": "Music Video"},
  {"catid":"209", "name": "Pop"},
  {"catid":"210", "name": "Rap"},
  {"catid":"211", "name": "RNB/Soul"},
  {"catid":"212", "name": "Rock"},
  {"catid":"213", "name": "Soundtrack"},
  {"catid":"214", "name": "Street beats"},
  {"catid":"215", "name": "Urban Vibes"},
];
